import { render, staticRenderFns } from "./editNote.vue?vue&type=template&id=328c72aa&xmlns%3Awidth=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml&"
import script from "./editNote.vue?vue&type=script&lang=js&"
export * from "./editNote.vue?vue&type=script&lang=js&"
import style0 from "./editNote.vue?vue&type=style&index=0&lang=styl&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports